import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt, faBookOpen, faTags } from "@fortawesome/free-solid-svg-icons";
import Highlight from "./ui/Highlight";

const Highlights = () => {
  return (
    <section id="highlights">
      <div className="container">
        <div className="row">
          <h2 className="section__title">
            Why Choose <span className="purple">Library</span>
          </h2>
          <div className="highlight__wrapper">
            
            <Highlight icon={<FontAwesomeIcon icon={faBookOpen} />} subtitle="Vast Collection" para="Access a wide range of books across various genres and categories." />
            
            <Highlight icon={<FontAwesomeIcon icon={faBolt} />} subtitle="Easy and Quick" para="Find and borrow books quickly and easily with our user-friendly platform." />

            <Highlight icon={<FontAwesomeIcon icon={faTags} />} subtitle="Affordable" para="Enjoy our library services at competitive and affordable rates." />            

            
          </div>
        </div>
      </div>
    </section>
  );
};

export default Highlights;
